import { createAsyncTypes } from '../utils';

export const FETCH_DOCUMENTS = createAsyncTypes('FETCH_DOCUMENTS');
export const DOCKETS_POPUP = 'DOCKETS_POPUP';
export const UPDATE_DOCKETS_PARTS = 'UPDATE_DOCKETS_PARTS';
export const RESET_DOCKETS_PARTS = 'RESET_DOCKETS_PARTS';
export const DOCKETS_FAVORITE_EMAIL = 'DOCKETS_FAVORITE_EMAIL';
export const DOCKETS_FAVORITE_EMAILS = 'DOCKETS_FAVORITE_EMAILS';
export const UPDATE_DOCKET_HEADER = 'UPDATE_DOCKET_HEADER';
export const UPDATE_DOCKET_DETAILS = 'UPDATE_DOCKET_DETAILS';
export const UPDATE_REDACT = 'UPDATE_REDACT';
export const UPDATE_DOCKETS = 'UPDATE_DOCKETS';
export const UPDATE_SELECTED_DOCKET = 'UPDATE_SELECTED_DOCKET';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const SET_RECEIPT = 'SET_RECEIPT';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/docketsActionTypes.js